import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaDownload, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { homeData } from '../data/home';
import { aboutData } from '../data/about';
import TerminalHero from '../components/TerminalHero';
import './Home.css';

const Home = () => {
  const home = homeData;
  const about = aboutData;


  return (
    <section id="home" className="home-section">

      {/* Background orbs */}
      <div className="home-orb home-orb--1" />
      <div className="home-orb home-orb--2" />

      <div className="home-container">

        {/* ── Left column ── */}
        <div className="home-left">
          <p className="home-greeting">Hello, I'm</p>
          <h1 className="home-name">{home.name}</h1>
          <h2 className="home-title">{home.title}</h2>

          <div className="home-location">
            <FaMapMarkerAlt />
            Atlanta, GA, USA
          </div>

          <p className="home-bio">{about.description}</p>

          <div className="home-buttons">
            <a href="#projects" className="btn btn-primary">
              {home.cta.primary} <FaArrowRight />
            </a>
            <a href="#contact" className="btn btn-secondary">
              {home.cta.secondary}
            </a>
            <a
              href="/logos/Affan Burney - Platform_Devops Engineer.pdf"
              download="Affan_Burney_Resume.pdf"
              className="btn btn-resume"
            >
              <FaDownload /> Resume
            </a>
          </div>

          <div className="home-social">
            <a href={home.social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={home.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={home.social.email} aria-label="Email">
              <FaEnvelope />
            </a>
          </div>
        </div>

        {/* ── Right column — terminal ── */}
        <div className="home-right">
          <TerminalHero />
        </div>

      </div>


    </section>
  );
};

export default Home;
